import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { getJetCallReportStatusSummary } from 'api/admin/jet/getJetCallReportStatusSummary'
import { jetKeys } from './keys'

export const useJetCallReportStatusSummaryQuery = (
  request: Parameters<typeof getJetCallReportStatusSummary>[0] = {}
) => {
  return useQuery({
    queryKey: jetKeys.statusSummary(request),
    queryFn: () => getJetCallReportStatusSummary(request),
    placeholderData: keepPreviousData,
  })
}
